<template>
  <div>
    <label class="text-sm font-medium text-gray-500">{{ $t('contact.email_addresses') }}</label>
    <div class="flex space-x-2 group">
      <p class="flex-1 text-gray-900 mt2 truncate">
        {{ concatenatedEmailAddresses || $t('global.not_set') }}
      </p>

      <div class="hidden flex-none group-hover:block">
        <EmailAddressesPropertyEditAction :contact-id="contactId" />
      </div>
    </div>
  </div>
</template>

<script>
import EmailAddressesPropertyEditAction from './emailAddressesProperty/EmailAddressesPropertyEditAction.vue';

export default {
  components: {
    EmailAddressesPropertyEditAction,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId];
    },
    concatenatedEmailAddresses() {
      return (this.contact?.emailAddresses || [])
        .map((emailAddressId) => this.$store.state.entities.emailAddresses.byId[emailAddressId])
        .filter(Boolean)
        .map((emailAddress) => emailAddress.address)
        .join(', ');
    },
  },
};
</script>
